<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp
      :search-show="true"
      @onSearch="attachData"
      @onReset="onResetParams"
    >
      <template>
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row align-end">
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">Thông tin</div>
                  <input v-model="searchParams.info" type="text" />
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp4"
                      v-model="searchParams.notActive"
                      type="checkbox"
                    />
                    <label for="cpSpdTp4">{{
                      $t('searchBox.showInactivedAccount')
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="false"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        :context="context"
        @selectionChanged="onMainRowSelectionChange"
        @refresh="onRefresh"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers m-0">
      <button
        :disabled="!isArAccountRowSelected"
        class="btn primary small outline"
        @click="deleteArAccount"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="!isArAccountRowSelected"
        class="btn primary small outline"
        @click="openEditDialog"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openDialog">
        {{ $t('button.add') }}
      </button>
      <button
        :disabled="!isArAccountRowSelected"
        class="btn primary small"
        @click="openInvoiceDialog"
      >
        {{ $t('button.invoice') }}
      </button>
      <button
        :disabled="!isArAccountRowSelected"
        class="btn primary small"
        @click="openPaymentDialog"
      >
        {{ $t('button.payment') }}
      </button>
      <!-- <button :disabled="!isArAccountRowSelected" class="btn primary small">
        {{ $t('button.refund') }}
      </button> -->
      <button class="btn primary small" @click="downloadExcel">
        {{ $t('button.downloadExcel') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.titleArAccountUpdate')
          : $t('dialog.titleArAccountAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="900px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-group-title">Thông tin chung</div>
            <div class="das-form-row">
              <div class="das-form-col col-4">
                <validation-provider
                  rules="required|max:20"
                  name="Số tài khoản"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.accountNumber') }}:
                    </div>
                    <div class="child-w-80">
                      <input
                        v-model="submitForm.account_num"
                        v-numeric-only
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-4">
                <!-- <validation-provider
                  rules="required|integer"
                  :name="$t('validator.taxCode')"
                > -->
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.taxCode') }}:</div>
                  <div class="child-w-80">
                    <input
                      v-model="submitForm.tax_code"
                      v-numeric-only
                      type="text"
                    />
                  </div>
                </div>
                <!-- </validation-provider> -->
              </div>
              <div class="das-form-col col-4">
                <!-- <validation-provider
                  rules="required"
                  :name="$t('validator.taxCode')"
                > -->
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.address') }}:</div>
                  <div class="child-w-80">
                    <input v-model="submitForm.address" type="text" />
                  </div>
                </div>
                <!-- </validation-provider> -->
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-4">
                <validation-provider
                  rules="required|max:20"
                  name="Tên tài khoản"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.accountName') }}:
                    </div>
                    <div class="child-w-80">
                      <input
                        v-model="submitForm.name"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-4">
                <!-- <validation-provider
                  rules="required|integer"
                  :name="$t('validator.debtDate')"
                > -->
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.debtDate') }}:</div>
                  <div class="child-w-80">
                    <input
                      v-model="submitForm.day_owed_num"
                      v-numeric-only
                      type="text"
                    />
                  </div>
                </div>
                <!-- </validation-provider> -->
              </div>
              <div class="das-form-col col-4">
                <!-- <validation-provider
                  rules="required"
                  :name="$t('validator.email')"
                > -->
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.email') }}:</div>
                  <div class="child-w-80">
                    <input v-model="submitForm.email" type="text" />
                  </div>
                </div>
                <!-- </validation-provider> -->
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-4">
                <!-- <validation-provider
                  rules="required|max:20"
                  :name="$t('validator.maxDebtAmmount')"
                > -->
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.maxDebtAmmount') }}:</div>
                  <div class="child-w-80">
                    <input
                      v-model="submitForm.max_debt_amount"
                      type="text"
                      :readonly="isEdit"
                    />
                  </div>
                </div>
                <!-- </validation-provider> -->
              </div>
              <div class="das-form-col col-4">
                <!-- <validation-provider
                  rules="required"
                  :name="$t('validator.phoneNumber')"
                > -->
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.phoneNumber') }}:</div>
                  <div class="child-w-80">
                    <input
                      v-model="submitForm.phone_number"
                      v-numeric-only
                      type="text"
                    />
                  </div>
                </div>
                <!-- </validation-provider> -->
              </div>
              <div class="das-form-col col-4">
                <!-- <validation-provider
                  rules="required"
                  :name="$t('validator.active')"
                > -->
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.active') }}:</div>
                  <div class="checkbox-container">
                    <div class="checkbox-wrap">
                      <input
                        id="is_active"
                        v-model="submitForm.active"
                        type="checkbox"
                      />
                      <label for="is_active">{{ $t('field.active') }}</label>
                    </div>
                  </div>
                </div>
                <!-- </validation-provider> -->
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <!-- <validation-provider rules="required|max: 255" name="Mô tả"> -->
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.note') }}:</div>
                  <div class="child-w-80">
                    <textarea v-model="submitForm.note" rows="4" />
                  </div>
                </div>
                <!-- </validation-provider> -->
              </div>
            </div>
          </div>
          <div class="das-form-group">
            <div class="das-form-group-title">Liên hệ</div>
            <div v-loading="loading" style="height: 300px">
              <GridVx
                ref="contactGrid"
                :columns="contactCols"
                :auto-size-cell="false"
                dom-layout="scroll"
                :rows="submitForm.debit_account_contracts"
                class="agGrid"
                :context="context"
                @refresh="onRefresh"
              />
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateArAccount"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addArAccount">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Hóa đơn"
      :visible.sync="invoiceDialogVisible"
      :close-on-click-modal="false"
      width="900px"
      @close="onCloseDetailInvoiceDialog"
    >
      <!-- <div class="das-form-container">
        <div class="das-info-title">Thông tin tài khoản</div>
        <InfoList :columns="4">
          <template v-for="item in paymentDialogInfo">
            <template>
              <InfoListLabel :key="item.label">{{ item.label }}</InfoListLabel>
              <InfoListValue :key="item.value" style="width: 100px">{{
                Number(item.value).toLocaleString('en') || null
              }}</InfoListValue>
            </template>
          </template>
        </InfoList>
      </div> -->
      <div v-loading="loading" style="height: 300px">
        <GridVx
          ref="agGridInvoice"
          :columns="invoiceCols"
          :auto-size-cell="false"
          :auto-select-first-row="false"
          :row-multi-select-with-click="true"
          dom-layout="scroll"
          :rows="invoiceRows"
          class="agGrid"
          @refresh="onRefresh"
          @selectionChanged="invoiceRowSelectionChanged"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="invoiceDialogVisible = false"
          >
            {{ $t('button.close') }}
          </button>
          <!-- <button
            :disabled="invoiceRowsSelected.length === 0"
            class="btn primary small outline"
          >
            {{ $t('button.delete') }}
          </button> -->
          <!-- <button class="btn primary small" @click="onAddInvoice">
            {{ $t('button.add') }}
          </button> -->
          <button
            :disabled="invoiceRowsSelected.length !== 1"
            class="btn primary small"
            @click="openInvoiceDetailDialog"
          >
            Chi tiết hóa đơn
          </button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="Tạo hóa đơn"
      :visible.sync="addInvoiceDialogVisible"
      :close-on-click-modal="false"
      width="700px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span>Tài khoản công nợ</span>
                </div>
                <input v-model="invoiceSubmitForm.name" disabled type="text" />
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span class="required">Trang GD</span>
                </div>
                <el-select
                  v-model="invoiceSubmitForm.trans_page"
                  placeholder=""
                >
                  <el-option
                    v-for="(option, index) in tranpageOptions"
                    :key="index"
                    :label="option.code"
                    :value="option.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">Ngày GD</div>
                <SingleCalendar v-model="invoiceSubmitForm.trans_date" />
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span>Thanh toán</span>
                </div>
                <div style="display: flex; align-items: center; gap: 10px">
                  <input
                    v-model="invoiceSubmitForm.money"
                    type="text"
                    style="flex: 2"
                  />
                  <el-select
                    v-model="invoiceSubmitForm.currency_id"
                    style="flex: 1"
                    placeholder=""
                  >
                    <el-option :key="9999" :value="null" label="VND" />
                    <!-- <el-option
                      v-for="item in subTransactionList"
                      :key="item.id"
                      :label="item.description"
                      :value="item.id"
                    >
                    </el-option> -->
                  </el-select>
                  <!-- <select style="flex: 1">
                        <option>VND</option>
                      </select> -->
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span class="required">Mã đặt phòng</span>
                </div>
                <el-select
                  v-model="invoiceSubmitForm.sub_booking_group_id"
                  placeholder=""
                >
                  <el-option
                    v-for="(option, index) in transactionBookingOptions"
                    :key="index"
                    :label="option.name"
                    :value="option.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  <span class="required">Loại GD</span>
                </div>
                <el-select
                  v-model="invoiceSubmitForm.sub_transaction_id"
                  placeholder=""
                >
                  <el-option
                    v-for="(option, index) in paymentMethods"
                    :key="index"
                    :label="option.c_method_nm"
                    :value="option.c_method_id"
                  />
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">Ghi chú</div>
                <textarea v-model="invoiceSubmitForm.note" :rows="3" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addInvoiceDialogVisible = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="onAddNewInvoice">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="Chi tiết hóa đơn"
      :visible.sync="isDetailInvoiceDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="das-info-title mt-0">Thông tin chi tiết của hóa đơn</div>
      <InfoList :columns="3">
        <template>
          <InfoListLabel>Tên tài khoản công nợ</InfoListLabel>
          <InfoListValue style="width: 100px">{{
            detailInvoiceInfo.name
          }}</InfoListValue>

          <InfoListLabel>Trang GD</InfoListLabel>
          <InfoListValue style="width: 100px">{{
            detailInvoiceInfo.trans_page
          }}</InfoListValue>

          <InfoListLabel>Số tiền</InfoListLabel>
          <InfoListValue style="width: 100px"
            >{{
              $displayCurrency(detailInvoiceInfo.original_total)
            }}
            VNĐ</InfoListValue
          >

          <InfoListLabel>Ngày tạo</InfoListLabel>
          <InfoListValue style="width: 100px">{{
            $displayDate(detailInvoiceInfo.create_date)
          }}</InfoListValue>

          <!-- <InfoListLabel>Mô tả</InfoListLabel>
          <InfoListValue style="width: 100px">Mô tả</InfoListValue> -->
        </template>
      </InfoList>
      <div class="das-info-title mb-10">Danh sách thanh toán hóa đơn</div>
      <div v-loading="loading" style="height: 200px">
        <GridVx
          ref="agGridInvoice"
          :columns="invoiceDetailCols"
          :auto-size-cell="true"
          :auto-select-first-row="false"
          dom-layout="scroll"
          :rows="invoiceDetailRows"
          class="detailInvoiceAgGrid"
        />
      </div>
      <hr />
      <div class="das-info-title mb-10">Danh sách GD thuộc hóa đơn</div>
      <div v-loading="loading" style="height: 200px">
        <GridVx
          ref="agGridInvoice"
          :columns="transactionListCols"
          :auto-size-cell="false"
          :auto-select-first-row="false"
          dom-layout="scroll"
          :rows="transactionListRows"
          class="detailInvoiceAgGrid"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="isDetailInvoiceDialog = false"
          >
            Đóng
          </button>
        </div>
      </span>
    </el-dialog>
    <payment-component
      ref="paymentComp"
      :debt-account-id="selectedRowId"
      :main-selected-row="selectedRow"
    />
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { downloadFile } from '@/utils/file-handler'
import DasButton from '@/components/ui/DasButton.vue'
import {
  getListArAccount,
  addArAccountApi,
  getArAccountById,
  updateArAccountApi,
  deleteArAccount,
  getListInvoiceByArAccount,
  downloadArAccountList,
  getRoomTransactionBooking,
  addNewInvoice,
  getInvoiceByPaymentApi
} from '@/api/accounting/ar-account'
import { getTransactionConfig } from '@/api/cashier_service/postTransaction'
import { getCodeBase } from '@/api/common/code_base'
import {
  CellRenderCheckboxReadonly,
  CellRenderTextInput,
  CellHeaderAddIcon,
  CellRenderDeleteIcon
} from '@/utils/cellRenders'
import PaymentComponent from './components/paymentComponent.vue'
export default {
  components: {
    DasButton,
    CellRenderCheckboxReadonly,
    CellRenderTextInput,
    CellHeaderAddIcon,
    CellRenderDeleteIcon,
    PaymentComponent
  },
  data() {
    return {
      detailInvoiceInfo: {
        name: null,
        trans_page: null,
        original_total: null,
        create_date: null
      },
      isDetailInvoiceDialog: false,
      invoiceRowsSelected: [],
      testValue: null,
      invoiceRows: [],
      selectedRow: null,
      selectedRowId: null,
      paymentMethods: [],
      invoiceSubmitForm: {
        money: null,
        note: null,
        sub_booking_group_id: null,
        sub_transaction_id: null,
        trans_date: null,
        trans_page: null,
        invoice_num: null,
        bank_account_id: null,
        currency_id: null,
        name: null
      },
      tranpageOptions: [],
      transactionBookingOptions: [],
      addInvoiceDialogVisible: false,
      invoiceDetailCols: [
        {
          headerName: 'Số phiếu thanh toán',
          field: 'payment_num',
          tooltipField: 'payment_num'
        },
        {
          headerName: 'Ngày thanh toán',
          field: 'pay_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.pay_date) || null
          },
          tooltipValueGetter: param => {
            return this.$displayDate(param?.data?.pay_date) || null
          }
        },
        {
          headerName: 'Số tiền thanh toán',
          field: 'money',
          cellClass: 'ag-cell-right',
          valueGetter: param => {
            return this.$displayCurrency(param?.data?.money) || null
          },
          tooltipValueGetter: param => {
            return this.$displayCurrency(param?.data?.money) || null
          }
        }
      ],
      invoiceDetailRows: [],
      invoicePaymentCols: [
        {
          headerName: 'Số HĐ',
          field: 'invoice_number_sequence'
        },
        {
          headerName: 'Mô tả',
          field: 'description'
        },
        // {
        //   headerName: 'Thông tin',
        //   field: 'trans_page'
        // },
        {
          headerName: 'Trang GD',
          field: 'trans_page'
        },
        {
          headerName: 'Số tiền gốc',
          field: 'original_total',
          valueGetter: param => {
            if (param?.data?.original_total) {
              return this.$displayCurrency(param.data.original_total)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Số dư',
          field: 'surplus',
          cellClass: 'ag-cell-right',
          valueGetter: param => {
            if (param?.data?.surplus) {
              return this.$displayCurrency(param.data.surplus)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Số tiền được áp dụng',
          field: 'appliedAmount',
          cellClass: 'ag-cell-right',
          valueGetter: param => {
            if (param?.data?.appliedAmount) {
              return this.$displayCurrency(param.data.appliedAmount)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'GL Origin',
          field: 'gl_original',
          valueGetter: param => {
            if (param?.data?.gl_original) {
              return this.$displayCurrency(param.data.gl_original)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Số dư sổ cái',
          field: 'trans_page'
        },
        {
          headerName: 'GL Applied',
          field: 'trans_page'
        }
      ],
      transactionListCols: [
        {
          headerName: 'Ngày GD',
          field: 'transactions_date',
          tooltipField: 'transactions_date',
          maxWidth: 140
        },
        {
          headerName: 'Mã GD',
          field: 'transactions_code',
          tooltipField: 'transactions_code',
          maxWidth: 140
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          tooltipField: 'description',
          width: 200
        },
        {
          headerName: 'Số tiền',
          field: 'transactions_money',
          cellClass: 'ag-cell-right',
          valueGetter: param => {
            if (param?.data?.transactions_money) {
              return this.$displayCurrency(param.data.transactions_money)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Người thực hiện',
          field: 'transactions_user_name',
          tooltipField: 'transactions_user_name'
        },
        {
          headerName: 'Ghi chú',
          field: 'transactions_note',
          tooltipField: 'transactions_note',
          minWidth: 300,
          flex: 1
        }
      ],
      transactionListRows: [],
      invoicePaymentRows: [],
      invoiceCols: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Trang GD',
          field: 'trans_page',
          tooltipField: 'trans_page'
        },
        {
          headerName: 'Ngày tạo',
          field: 'create_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.create_date) || null
          },
          tooltipValueGetter: param => {
            return this.$displayDate(param?.data?.create_date) || null
          }
        },

        {
          headerName: 'Số tiền',
          field: 'surplus',
          valueGetter: param => {
            if (param?.data?.surplus) {
              return this.$displayCurrency(param.data.surplus)
            } else {
              return 0
            }
          },
          tooltipValueGetter: param => {
            if (param?.data?.surplus) {
              return this.$displayCurrency(param.data.surplus)
            } else {
              return 0
            }
          }
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          tooltipField: 'description'
        }
      ],
      invoiceRows: [],
      invoiceDialogVisible: false,
      isArAccountRowSelected: false,
      context: null,
      refundMethods: [
        {
          name: 'Tiền mặt'
        },
        {
          name: 'Chuyển khoản'
        },
        {
          name: 'Khác'
        }
      ],
      loading: false,
      applyPaymentDialog: false,
      paymentDialogInfo: [
        {
          label: 'Số dư hóa đơn',
          value: 10000
        },
        {
          label: 'Số dư thanh toán',
          value: 10000
        },
        {
          label: 'Số tiền hoàn',
          value: 10000
        },
        {
          label: 'Số dư tài khoản',
          value: 10000
        }
      ],
      accountDialogInfo: [
        {
          label: 'Tài khoản',
          value: 'Dasvision 1'
        },
        {
          label: 'Số dư',
          value: 10000
        }
      ],
      paymentDialogInfo: [
        {
          label: 'Thanh toán',
          value: '17'
        },
        {
          label: 'Tổng',
          value: 500000
        },
        {
          label: 'Bỏ áp dụng',
          value: 500000
        },
        {
          label: 'Đã chọn',
          value: 500000
        }
      ],
      paymentCols: [
        {
          headerName: 'GL Period',
          field: 'gl_period'
        },
        {
          headerName: 'Inv Pay Num',
          field: 'inv_pay_num'
        },
        {
          headerName: 'Mô tả',
          field: 'note'
        },
        // {
        //   headerName: 'Trang giao dịch',
        //   field: 'code'
        // },
        {
          headerName: 'Tổng',
          field: 'original_total',
          valueGetter: param => {
            if (param.data.original_total) {
              return this.$displayCurrency(param.data.original_total)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Chưa áp dụng',
          field: 'money',
          valueGetter: param => {
            if (param.data.money) {
              return this.$displayCurrency(param.data.money)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Ngày tạo',
          field: 'create_date',
          valueGetter: param => {
            if (param.data.create_date) {
              return this.$displayDate(param.data.create_date)
            } else {
              return null
            }
          }
        },
        // {
        //   headerName: 'Đã trả trước',
        //   field: 'code'
        // },
        {
          headerName: 'Đã áp dụng',
          field: 'gl_original',
          valueGetter: param => {
            if (param.data.gl_original) {
              return this.$displayCurrency(param.data.gl_original)
            } else {
              return null
            }
          }
        }
        // {
        //   headerName: 'Loại',
        //   field: 'code'
        // }
      ],
      paymentRows: [
        {
          code: 'Test data 1'
        }
      ],
      columns: [
        {
          headerName: this.$t('grid.column.accountNum'),
          field: 'account_num',
          tooltipField: 'account_num',
          maxWidth: 180
        },
        {
          headerName: this.$t('grid.column.accountName'),
          field: 'name',
          tooltipField: 'name',
          maxWidth: 180
        },
        {
          headerName: this.$t('grid.column.surplus'),
          field: 'debit',
          valueGetter: param => {
            if (param?.data?.debit) {
              return this.$displayCurrency(param.data.debit)
            } else {
              return 0
            }
          },
          tooltipValueGetter: param => {
            if (param?.data?.debit) {
              return this.$displayCurrency(param.data.debit)
            } else {
              return 0
            }
          },
          maxWidth: 180
        },
        {
          headerName: this.$t('grid.column.taxCode'),
          field: 'tax_code',
          tooltipField: 'tax_code',
          maxWidth: 180
        },
        {
          headerName: this.$t('grid.column.email'),
          field: 'email',
          flex: 1,
          minWidth: 180,
          tooltipField: 'email'
        },
        {
          headerName: this.$t('grid.column.phoneNum'),
          field: 'phone_number',
          tooltipField: 'phone_number',
          maxWidth: 180
        },
        {
          headerName: this.$t('grid.column.debtPeriod'),
          field: 'day_owed_num',
          tooltipField: 'day_owed_num',
          maxWidth: 180
        },
        {
          headerName: this.$t('grid.column.debtMax'),
          field: 'max_debt_amount',
          valueGetter: param => {
            if (param?.data?.max_debt_amount) {
              return this.$displayCurrency(param.data.max_debt_amount)
            } else {
              return 0
            }
          },
          tooltipValueGetter: param => {
            if (param?.data?.max_debt_amount) {
              return this.$displayCurrency(param.data.max_debt_amount)
            } else {
              return 0
            }
          }
        },
        {
          headerName: this.$t('grid.column.active'),
          field: 'active',
          maxWidth: 100,
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly'
        }
      ],
      contactCols: [
        {
          headerName: this.$t('grid.column.name'),
          field: 'name',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: this.$t('grid.column.position'),
          field: 'position',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: this.$t('grid.column.email'),
          field: 'email',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: this.$t('grid.column.phone1'),
          field: 'phone_number_1',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: this.$t('grid.column.phone2'),
          field: 'phone_number_2',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: '',
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          headerComponent: 'CellHeaderAddIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          },
          cellRendererParams: () => {
            return {
              agGrid: 'contactGrid'
            }
          }
        }
      ],
      rowId: null,
      dialogPayment: false,
      rows: [],
      contactRows: [
        {
          name: null,
          position: null,
          email: null,
          phone_number_1: null,
          phone_number_2: null,
          note: null
        }
      ],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC',
        info: null,
        notActive: false
      },
      submitForm: {
        name: null,
        address: null,
        email: null,
        active: false,
        note: null,
        account_num: null,
        tax_code: null,
        day_owed_num: null,
        max_debt_amount: null,
        phone_number: null,
        debit_account_contracts: [
          {
            name: null,
            position: null,
            email: null,
            note: null,
            debt_account_id: null,
            phone_number_1: null,
            phone_number_2: null
          }
        ]
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    },
    invoiceDialogVisible() {
      this.invoiceDialogVisible ? null : this.resetInvoiceDialog()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  async mounted() {
    this.attachData()
    const data = await getCodeBase({
      p_code: 'TRANPAGE'
    })
    this.tranpageOptions = data.data || []
    //
    const paymentData = await getTransactionConfig({ type: 1 })
    this.paymentMethods = this.paymentTransactionConfig =
      paymentData?.data.filter(item => item.method_nm === 'DEBT_PAYMENT')
  },
  methods: {
    onCloseDetailInvoiceDialog() {
      this.$nullValueInObj(this.detailInvoiceInfo)
      this.invoiceDetailRows = []
    },
    openInvoiceDetailDialog() {
      const invoiceSelectedRow = this.invoiceRowsSelected[0] || {}
      this.detailInvoiceInfo.name = this.selectedRow.name
      this.detailInvoiceInfo.trans_page = invoiceSelectedRow.trans_page
      this.detailInvoiceInfo.original_total = invoiceSelectedRow.original_total
      this.detailInvoiceInfo.create_date = invoiceSelectedRow.create_date

      //
      const rows = invoiceSelectedRow?.debt_account_payment_invoice || []
      this.invoiceDetailRows = rows

      //
      this.transactionListRows = invoiceSelectedRow.transactions || []
      this.isDetailInvoiceDialog = true
    },
    resetInvoiceDialog() {
      this.invoiceRows = []
      this.invoiceRowsSelected = []
    },
    invoiceRowSelectionChanged(rows) {
      this.invoiceRowsSelected = rows
    },
    async onAddNewInvoice() {
      console.log('onAddNewInvoice', this.invoiceSubmitForm)
      // await addNewInvoice(this.invoiceSubmitForm)
    },

    onMainRowSelectionChange(row) {
      this.isArAccountRowSelected = true
      this.selectedRow = row[0]
      this.selectedRowId = row[0].id
    },

    async getRoomTransactionBooking() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      const params = {
        debtAccountId: row.id
      }
      const data = await getRoomTransactionBooking(params)
      this.transactionBookingOptions = data.data
    },
    onAddInvoice() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      this.invoiceSubmitForm.debt_account_id = row.id || null
      this.invoiceSubmitForm.name = row.name || null
      this.getRoomTransactionBooking()
      this.addInvoiceDialogVisible = true
    },
    async downloadExcel() {
      bus.$emit('startLoader', { msg: '' })
      await downloadArAccountList(this.searchParams)
        .then(res => {
          downloadFile(res, 'Danh sách tài khoản công nợ.xlsx')
          this.$message({
            type: 'success',
            message: this.$t('successMsg.downloadSuccessful')
          })
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.downloadError')
          })
        })
        .finally(() => {
          bus.$emit('endLoader')
        })
    },
    async openInvoiceDialog() {
      this.invoiceDialogVisible = true
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      const params = {
        debtAccountId: row.id || null
      }
      const data = await getListInvoiceByArAccount(params)
      this.invoiceRows = data.data || []
    },
    onResetParams() {
      this.searchParams = {
        info: null,
        notActive: false,
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC'
      }
      this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async deleteArAccount() {
      const gridApi = this.$refs.agGrid.gridApi
      const rows = gridApi.getSelectedRows()
      const ids = rows.map(item => item.id) || []
      this.$vxConfirm('Bạn chắc chắc muốn xóa những bản ghi này?', async () => {
        await deleteArAccount({
          ids: ids
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async openEditDialog() {
      const gridApi = this.$refs.agGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id || null
      const data = await getArAccountById(id)
      Object.assign(this.submitForm, data.data || [])
      this.dialogFormVisible = true
      this.isEdit = true
    },
    onAddRowInGrid() {
      this.submitForm.debit_account_contracts.push({
        name: null,
        position: null,
        email: null,
        phone_number_1: null,
        phone_number_2: null,
        note: null
      })
    },
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.submitForm.debit_account_contracts.splice(idx, 1)
    },
    textInputChange(params, data, colName) {
      const idx = params.rowIndex
      if (colName === 'name') {
        this.submitForm.debit_account_contracts[idx]['name'] = data
      } else if (colName === 'position') {
        this.submitForm.debit_account_contracts[idx]['position'] = data
      } else if (colName === 'email') {
        this.submitForm.debit_account_contracts[idx]['email'] = data
      } else if (colName === 'phone_number_1') {
        this.submitForm.debit_account_contracts[idx]['phone_number_1'] = data
      } else if (colName === 'phone_number_2') {
        this.submitForm.debit_account_contracts[idx]['phone_number_2'] = data
      } else if (colName === 'note') {
        this.submitForm.debit_account_contracts[idx]['note'] = data
      }
    },
    async openPaymentDialog() {
      await this.$refs.paymentComp.getPaymentRows()
      this.$refs.paymentComp.paymentDialog = true
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.$nullValueInObj(this.submitForm)
      this.submitForm.debit_account_contracts = [
        {
          name: null,
          position: null,
          email: null,
          note: null,
          debt_account_id: null,
          phone_number_1: null,
          phone_number_2: null
        }
      ]
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    async addArAccount() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      if (isNaN(this.submitForm.account_num)) {
        this.$message({
          type: 'error',
          message: 'Số tài khoản phải là số'
        })
        return
      }
      // var payload = {
      //   ...this.submitForm,
      //   account_num: Number(this.submitForm.account_num)
      // }
      await addArAccountApi(this.submitForm)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateArAccount() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateArAccountApi(this.submitForm)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListArAccount(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    }
  }
}
</script>

<style lang="scss" scoped></style>
